import React from 'react';
import { SpaStatePageReady } from '@atlassian/jira-spa-state-controller/src/components/main.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { AuthenticationCheck } from '@atlassian/jira-spa-apps-common/src/interceptors/authentication/index.tsx';
import RouteWrapperHealthcheckPage from './ui/index.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const HealthcheckPage = (props: Record<any, any>): React.JSX.Element => (
	<UFOSegment name="applinks-extra-auth-healthcheck-page">
		<AuthenticationCheck>
			<RouteWrapperHealthcheckPage {...props} />
			<SpaStatePageReady />
		</AuthenticationCheck>
	</UFOSegment>
);

export default HealthcheckPage;
